import { IconExternalLink } from '@iwoca/icons';
import { Button, Spinner } from '@iwoca/orion';
import clsx from 'clsx';
import { TApplication } from 'lendingApi/applications.types';
import styles from './OpenInNewTabButton.module.css';
import { useOpenInNewTab } from './useOpenInNewTab.hook';

type TProps = {
  application: TApplication;
};

export const OpenInNewTabButton = ({ application }: TProps) => {
  const { isDE, isLoading, handleOpenNewTabClick } =
    useOpenInNewTab(application);

  return (
    <Button
      className={clsx(styles.newTabButton, {
        [styles.newTabButtonDE]: isDE,
      })}
      data-testid="open-in-new-tab-button"
      variant="tertiary"
      onClick={handleOpenNewTabClick}
    >
      {isLoading ? (
        <Spinner />
      ) : (
        <IconExternalLink className={styles.newTabIcon} />
      )}
    </Button>
  );
};
